import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddDeviceButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/devices/create?deviceCircle=${record['@id']}`}
    label="Add a device"
    title="Add a device"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddDeviceButton);
